import { NgModule } from '@angular/core';
import { TeamEngageDashboardComponent } from './team-engage-dashboard.component';
import { TeamEngageDashboardRoutingModule } from './team-engage-dashboard-routing.module';

@NgModule({
  imports: [
    TeamEngageDashboardComponent,
    TeamEngageDashboardRoutingModule
  ],
  exports: [],
})
export class TeamEngageDashboardModule {
}
